import React, { useState } from "react";
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton,
  Input, InputGroup, InputLeftElement, VStack, HStack, Box, Text, Button, Badge,
  Select, Spinner, Center, useToast,
} from "@chakra-ui/react";
import { Search } from "lucide-react";
import { buscarCrmClientes, addCrmCarteira } from "../../services/api";
import { formatDoc, formatPhone } from "./crmUtils";

const ACCENT = "#F68633";

export default function AdicionarContaModal({ isOpen, onClose, onAdded, vendedores, isAdmin }) {
  const [q, setQ] = useState("");
  const [resultados, setResultados] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [vendedorId, setVendedorId] = useState("");
  const [addId, setAddId] = useState(null);
  const toast = useToast();

  const buscar = async (e) => {
    e?.preventDefault?.();
    if (q.trim().length < 2) return;
    setBuscando(true);
    const r = await buscarCrmClientes(q.trim());
    setBuscando(false);
    setResultados(r?.data || []);
  };

  const adicionar = async (c) => {
    setAddId(c.id);
    const r = await addCrmCarteira({
      cliente_id: c.id,
      vendedor_user_id: isAdmin && vendedorId ? Number(vendedorId) : undefined,
    });
    setAddId(null);
    if (r?.data) {
      toast({ status: "success", title: "Conta adicionada à carteira" });
      onAdded?.();
      setResultados((prev) => prev.map((x) => (x.id === c.id ? { ...x, em_carteira: true } : x)));
    } else {
      toast({ status: "error", title: "Erro", description: r?.error || "Não foi possível adicionar." });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader fontSize="md">Adicionar conta à carteira</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <form onSubmit={buscar}>
            <HStack mb={3}>
              <InputGroup size="sm">
                <InputLeftElement pointerEvents="none"><Search size={15} color="#999" /></InputLeftElement>
                <Input placeholder="Buscar por nome, documento ou telefone..." value={q} onChange={(e) => setQ(e.target.value)} />
              </InputGroup>
              <Button size="sm" type="submit" colorScheme="orange" isLoading={buscando}>Buscar</Button>
            </HStack>
          </form>

          {isAdmin && (
            <Select size="sm" mb={3} placeholder="Atribuir a mim" value={vendedorId} onChange={(e) => setVendedorId(e.target.value)}>
              {(vendedores || []).map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
            </Select>
          )}

          {buscando ? (
            <Center py={8}><Spinner color={ACCENT} /></Center>
          ) : (
            <VStack align="stretch" spacing={2}>
              {resultados.length === 0 && <Text fontSize="sm" color="gray.400" textAlign="center" py={6}>Digite e busque um cliente.</Text>}
              {resultados.map((c) => (
                <Box key={c.id} borderWidth="1px" borderColor="gray.100" borderRadius="lg" p={3}>
                  <HStack justify="space-between">
                    <Box minW={0}>
                      <HStack>
                        <Text fontSize="sm" fontWeight="semibold" noOfLines={1}>{c.nome || "Sem nome"}</Text>
                        {c.tipo_doc && <Badge colorScheme={c.tipo_doc === "CNPJ" ? "purple" : "blue"}>{c.tipo_doc === "CNPJ" ? "PJ" : "PF"}</Badge>}
                      </HStack>
                      <Text fontSize="xs" color="gray.500" noOfLines={1}>
                        {c.documento ? formatDoc(c.documento) : "sem documento"} · {c.telefone ? formatPhone(c.telefone) : "sem telefone"}
                      </Text>
                    </Box>
                    {c.em_carteira ? (
                      <Badge colorScheme="green" flexShrink={0}>na carteira</Badge>
                    ) : (
                      <Button size="xs" colorScheme="orange" flexShrink={0} onClick={() => adicionar(c)} isLoading={addId === c.id}>Adicionar</Button>
                    )}
                  </HStack>
                </Box>
              ))}
            </VStack>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
